import { Root } from "./Root.styles";
import { Image } from "./Image.styles";
import { Fallback } from "./Fallback.styles";
import type { FallbackProps } from "./Fallback.styles";
import AvatarComponentBase from "./Avatar";
import type { Props as AvatarProps, Size as AvatarSize } from "./Avatar";

// Create a proper interface for the Avatar component with subcomponents
interface AvatarComponentType extends React.FC<AvatarProps> {
  Root: typeof Root;
  Image: typeof Image;
  Fallback: typeof Fallback;
}

// Cast the component to the extended type
const Avatar = AvatarComponentBase as AvatarComponentType;

// Attach subcomponents to the Avatar component
Avatar.Root = Root;
Avatar.Image = Image;
Avatar.Fallback = Fallback;

// Export the Avatar component
export { Avatar };
export default Avatar;

// Export types
export type { FallbackProps };
export type { AvatarProps, AvatarSize };
